import axios from "../../utils/axios";

export const getAllTransactions = async () => {
	const response = await axios.get("/transactions");

	return response.data;
};

export const getTransactions = async (search, currentPage, sortBy) => {
	let queryString = "";

	if (search !== "") {
		queryString += `&q=${search}`;
	}
	if (sortBy !== "") {
		queryString += `&type_like=${sortBy}`;
	}

	const response = await axios.get(
		`/transactions?_page=${currentPage}&_limit=5&_sort=id&_order=desc${queryString}`
	);

	return {
		transactions: response.data,
		pages: Math.ceil(response.headers["x-total-count"] / 5),
	};
};

export const addTransaction = async (data) => {
	const response = await axios.post("/transactions", data);

	return response.data;
};

export const removeTransaction = async (id) => {
	const response = await axios.delete("/transactions/" + id);

	return response.data;
};

export const editTransaction = async (id, data) => {
	const response = await axios.put("/transactions/" + id, data);

	return response.data;
};
